import styled from 'styled-components'

type ScrollProps = {
  isActiveWish?: boolean
  animated?: boolean
  listId?: string
}

type plantDisplay = {
  isActiveSlug?: string
  hidePlants?: boolean
}

type ComponentStyledProps = {
  isLastWish: boolean
}

export const WishScrollContainer = styled.div<plantDisplay>`
  .animations {
    /* transition: 0.25s ease-in; */
  }

  width: 100%;
  overflow: hidden;
  #sparks-animation {
    position: absolute;
    z-index: 0;
    bottom: 180px;
    left: 50%;
    transform: translateX(-50%);
    opacity: ${({ isActiveSlug }) => (isActiveSlug ? '1' : '0')};

    @media (max-width: ${({ theme }) => `${theme.breakpoints.values.md}px`}) {
      width: 80%;
      bottom: 200px;
    }

    @media (max-width: ${({ theme }) => `${theme.breakpoints.values.sm}px`}) {
      bottom: 130px;
      width: 160%;
    }
  }

  .plant-animation-container {
    position: absolute;
    z-index: 3;
    bottom: 73px;
    left: 50%;
    width: 350px;
    transform: translateX(-50%);
    pointer-events: none;

    @media (max-width: ${({ theme }) => `${theme.breakpoints.values.sm}px`}) {
      width: 240px;
      bottom: 53px;
    }
  }

  #animation-bean {
    transition: 0.5s ease-in;
    opacity: ${({ isActiveSlug }) => (isActiveSlug === 'bean' ? '1' : '0')};
  }
  #animation-lentils {
    transition: 0.4s ease-in;
    opacity: ${({ isActiveSlug }) => (isActiveSlug === 'lentils' ? '1' : '0')};
  }
  #animation-pearl-millet {
    transition: 0.4s ease-in;
    opacity: ${({ isActiveSlug }) => (isActiveSlug === 'pearl-millet' ? '1' : '0')};
  }
  #animation-peas {
    transition: 0.4s ease-in;
    opacity: ${({ isActiveSlug }) => (isActiveSlug === 'peas' ? '1' : '0')};
  }
  #animation-sorghum {
    transition: 0.4s ease-in;
    opacity: ${({ isActiveSlug }) => (isActiveSlug === 'sorghum' ? '1' : '0')};
  }

  .plants {
    .plant-wrapper {
      z-index: 2;
      opacity: ${({ hidePlants }) => (hidePlants ? '0' : '1')};
      /* transition: opacity 2s ease-in; */

      @media (max-width: ${({ theme }) => `${theme.breakpoints.values.sm}px`}) {
        &.active {
          .milestone {
            .main-box {
              flex-direction: row;
              min-width: 250px;
              left: 50%;
              transform: translateX(-50%);

              .wish-info,
              .seed-info {
                padding: 0;
              }
            }
          }
        }
      }
    }

    .next-milestone {
      width: 100%;
      min-width: 800px;
      opacity: ${({ hidePlants }) => (hidePlants ? '0' : '1')};
      /* transition: opacity 2s ease-in; */

      @media (max-width: ${({ theme }) => `${theme.breakpoints.values.md}px`}) {
        min-width: 400px;
      }

      @media (max-width: ${({ theme }) => `${theme.breakpoints.values.sm}px`}) {
        min-width: 250px;
      }
    }
  }
`

export const LimitScroll = styled.div`
  padding-right: 780px;
  height: 375px;
  width: 20px;

  @media (max-width: ${({ theme }) => `${theme.breakpoints.values.md}px`}) {
    padding-right: 380px;
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.values.sm}px`}) {
    padding-right: 230px;
  }
`

export const ComponentStyled = styled.div<ComponentStyledProps>`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;

  .global-page-wrapper {
    background-color: ${({ theme }) => theme.colors.brown2};
    padding: 60px 0 0 0;
    display: flex;
    flex-direction: column;

    @media (max-width: ${({ theme }) => `${theme.breakpoints.values.md}px`}) {
      padding: 140px 0 0 0;
    }

    .title-container {
      flex: 1;
      z-index: 1;

      .page-title {
        font-family: 'Playfair Display';
        font-weight: 900;
        font-size: 48px;
        line-height: 48px;
        letter-spacing: 0.01em;
        color: ${({ theme }) => theme.colors.black};
        text-align: center;
        margin-bottom: 25px;

        @media (max-width: ${({ theme }) => `${theme.breakpoints.values.sm}px`}) {
          font-size: 24px;
          letter-spacing: -0.02em;
          max-width: 250px;
          line-height: 100%;
          margin: auto;
        }
      }

      .last-wish-copy-wrapper {
        display: flex;
        justify-content: center;
        visibility: ${({ isLastWish }) => (isLastWish ? 'hidden' : 'visible')};

        .last-wish-copy {
          cursor: pointer;
          font-family: 'Cabin';
          font-weight: 700;
          font-size: 13px;
          line-height: 14px;
          letter-spacing: 0.03em;
          text-transform: uppercase;
          color: ${({ theme }) => theme.colors.black};
          text-align: center;
          flex-direction: column;
          display: flex;
          align-items: center;

          .arrow {
            margin-top: 10px;
          }
        }

        @media (max-width: ${({ theme }) => `${theme.breakpoints.values.sm}px`}) {
          display: none;
        }
      }
    }

    .bottom-plants {
      width: 100%;
      padding-bottom: 135px;
      min-height: 835px;

      @media (max-width: ${({ theme }) => `${theme.breakpoints.values.sm}px`}) {
        min-height: 680px;
      }

      .milestone-control {
        position: absolute;
        top: 50%;
        font-family: 'Cabin';
        font-weight: 700;
        font-size: 13px;
        line-height: 14px;
        letter-spacing: 0.03em;
        text-transform: uppercase;
        color: ${({ theme }) => theme.colors.black};
        z-index: 2;
        max-width: 140px;
        display: flex;
        align-items: center;
        cursor: pointer;
        z-index: 6;
        padding: 20px;

        @media (max-width: ${({ theme }) => `${theme.breakpoints.values.xl}px`}) {
          top: 45%;
        }

        @media (max-width: ${({ theme }) => `${theme.breakpoints.values.sm}px`}) {
          top: initial;
          bottom: 60px;
          color: ${({ theme }) => theme.colors.secondaries.opacity100};
        }

        .arrow {
          max-width: 9px;
          min-width: 9px;
          max-height: 16px;
          min-height: 16px;

          path {
            fill: ${({ theme }) => theme.colors.black};

            @media (max-width: ${({ theme }) => `${theme.breakpoints.values.sm}px`}) {
              fill: ${({ theme }) => theme.colors.secondaries.opacity100};
            }
          }
        }

        &.center {
          display: none;

          @media (max-width: ${({ theme }) => `${theme.breakpoints.values.sm}px`}) {
            display: block;
            transform: translateX(-50%);
            left: 50%;
          }
        }

        &.left {
          left: 35px;
          text-align: left;
          justify-content: flex-start;

          @media (max-width: ${({ theme }) => `${theme.breakpoints.values.sm}px`}) {
            left: 0;
          }

          .arrow {
            margin-right: 15px;
          }
        }

        &.right {
          text-align: right;
          right: 35px;
          justify-content: flex-end;

          @media (max-width: ${({ theme }) => `${theme.breakpoints.values.sm}px`}) {
            right: 0;
          }

          .arrow {
            margin-left: 15px;
          }
        }
      }

      .scroll-container {
        &::before {
          content: '';
          position: absolute;
          bottom: 0;
          width: 100%;
          height: 255px;
          background-position: top;
          background-size: cover;
          background-image: url('/images/terrain.svg');
          z-index: 1;

          @media (max-width: ${({ theme }) => `${theme.breakpoints.values.sm}px`}) {
            height: 180px;
          }
        }

        .plants-container {
          position: relative;
          min-height: 700px;
          min-width: auto;

          @media (max-width: ${({ theme }) => `${theme.breakpoints.values.sm}px`}) {
            min-height: 550px;
          }
        }

        .plants {
          display: flex;
          align-items: flex-end;
          min-height: 700px;
          min-width: auto;

          @media (max-width: ${({ theme }) => `${theme.breakpoints.values.sm}px`}) {
            min-height: 550px;
          }

          .next-milestone {
            position: relative;
            height: 440px;
            display: flex;
            justify-content: flex-end;

            .next-milestone-wrapper {
              position: absolute;
              bottom: 64px;
              left: 100px;

              @media (max-width: ${({ theme }) => `${theme.breakpoints.values.xl}px`}) {
                left: 150px;
                bottom: 0px;
              }

              @media (max-width: ${({ theme }) => `${theme.breakpoints.values.md}px`}) {
                display: none;
              }
            }
          }

          .plant-wrapper {
            position: relative;
            cursor: pointer;
            min-width: 320px;
            height: 436px;
            display: flex;
            align-items: flex-end;
            justify-content: center;

            @media (max-width: ${({ theme }) => `${theme.breakpoints.values.xl}px`}) {
              min-width: 230px;
              height: 350px;
            }

            @media (max-width: ${({ theme }) => `${theme.breakpoints.values.lg}px`}) {
              min-width: 160px;
              height: 312px;
            }

            @media (max-width: ${({ theme }) => `${theme.breakpoints.values.sm}px`}) {
              min-width: 140px;
              height: 280px;
            }

            &.active {
              margin: 0;
              /* transition: 0.2s ease-in-out; */

              @media (max-width: ${({ theme }) => `${theme.breakpoints.values.sm}px`}) {
                min-width: 140px;
              }

              .plant-img {
                height: 470px;
                /* transition: 0.75s ease-in-out; */
              }
            }

            .wish-wrapper {
              min-width: 400px;
              margin-top: 100px;
              animation: slideUp 1s;
              position: absolute;
              top: -350px;
              left: 50%;
              transform: translateX(-50%);

              .milestone-control {
                position: absolute;
                &.left {
                  top: 50px;
                  left: 0;
                  transform: translateX(-100%);
                }

                &.right {
                  top: 50px;
                  right: 0;
                  transform: translateX(100%);
                }
              }

              .wish-item-wrapper {
                position: relative;
                z-index: -1;

                .seed {
                  position: absolute;
                  bottom: -20px;
                  left: 50%;
                  transform: translateX(-50%);
                }
              }

              .seed-copy {
                text-align: center;
                font-family: 'Playfair Display';
                font-weight: 900;
                font-size: 28px;
                line-height: 28px;
                letter-spacing: -0.04em;
                color: ${({ theme }) => theme.colors.black};
                margin-top: 30px;

                span {
                  color: ${({ theme }) => theme.colors.red};
                }

                @media (max-width: ${({ theme }) => `${theme.breakpoints.values.sm}px`}) {
                  font-size: 16px;
                }
              }

              @media (max-width: ${({ theme }) => `${theme.breakpoints.values.sm}px`}) {
                min-width: 220%;
              }
            }

            .milestone {
              position: absolute;
              left: 15px;
              right: 15px;
              top: 0px;

              @media (max-width: ${({ theme }) => `${theme.breakpoints.values.xl}px`}) {
                top: -30px;
                left: initial;
                right: initial;
              }

              @media (max-width: ${({ theme }) => `${theme.breakpoints.values.sm}px`}) {
                top: -100px;
              }
            }

            .plant-img {
              height: 375px;
              min-width: 230px;
              overflow: hidden;

              @media (max-width: ${({ theme }) => `${theme.breakpoints.values.sm}px`}) {
                height: 280px;
                min-width: 100%;
                position: relative;
                bottom: -7px;
              }
            }
          }
        }
      }
    }
  }

  @keyframes slideUp {
    from {
      top: 0;
      opacity: 0;
    }
    to {
      top: -350px;
      opacity: 1;
    }
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.values.sm}px`}) {
    @keyframes slideUp {
      from {
        top: -70px;
        opacity: 0;
      }
      to {
        top: -350px;
        opacity: 1;
      }
    }
  }
`

export const Loading = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const PlantImage = styled.div<ScrollProps>`
  .plant-image-container {
    /* transition: opacity 0.25s ease-in-out; */
    opacity: ${({ isActiveWish /*, animated*/ }) => (isActiveWish /*&& !animated*/ ? '0' : '1')};
    width: 100%;
    height: 375px;
    position: relative;
    bottom: ${({ isActiveWish, animated }) => (isActiveWish && !animated ? '-80px' : isActiveWish ? '16px' : '16px')};
    pointer-events: none;

    @media (max-width: ${({ theme }) => `${theme.breakpoints.values.sm}px`}) {
      transition: none;
      opacity: ${({ isActiveWish, animated }) => (isActiveWish && !animated ? '0' : '1')};
      bottom: ${({ isActiveWish, animated }) =>
        isActiveWish && !animated ? '-80px' : isActiveWish ? '-174px' : '16px'};
      min-width: 100%;
    }
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.values.sm}px`}) {
    min-width: 100%;
  }
`
